// Resolves the Media Matchers publisher identification params from the URL.
//
// Rules (per partner spec):
//  - If `mPubGroupID` is present in the URL, use it (ignore mPubID/mPubCampaignID).
//  - Else if BOTH `mPubID` and `mPubCampaignID` are present, use those.
//  - Otherwise fall back to the call site's existing/default publisher params.
//
// Either `mPubGroupID` is sent, OR the `mPubID` + `mPubCampaignID` pair — never
// a mix. Pass the current `location.search` (or window.location.search) plus the
// call site's default params; spread the result into the outgoing query.
export function getPublisherParams(
  search: string,
  fallback: Record<string, string>,
): Record<string, string> {
  const params = new URLSearchParams(search)
  const mPubGroupID = params.get('mPubGroupID')
  if (mPubGroupID) {
    return { mPubGroupID }
  }
  const mPubID = params.get('mPubID')
  const mPubCampaignID = params.get('mPubCampaignID')
  if (mPubID && mPubCampaignID) {
    return { mPubID, mPubCampaignID }
  }
  return { ...fallback }
}
